// Schema.org para los rich results de Google: las tres sedes como eventos
// independientes mas un FAQPage.
import { faqs } from './Faqs';
// Las sedes vienen de data/events.js. Estaban copiadas aqui, en Countdown.js
// y en Locations.js, y ya se habian desincronizado: este archivo se habia
// quedado con la direccion antigua de Monterrey.
import events from '../data/events';

const SITE = 'https://conferenciaparacanada.com';

const DESCRIPTION =
    'Conferencia gratuita para conocer las mejores provincias de Canadá para estudiar, ' +
    'trabajar y migrar. Acceso directo a instituciones educativas canadienses, un asesor laboral ' +
    'especializado y un consultor migratorio regulado por el Gobierno de Canadá.';

const organizer = {
    '@type': 'Organization',
    name: 'Para Canadá',
    url: SITE
};

// FAQPage: puede ganar resultado expandido en Google. Las preguntas salen
// del mismo array que renderiza el acordeon.
const faqPage = {
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
            '@type': 'Answer',
            text: faq.answer
        }
    }))
};

const eventSchema = {
    '@context': 'https://schema.org',
    '@graph': events.map((event) => ({
        '@type': 'Event',
        name: `Conferencia para Canadá en ${event.city}`,
        description: DESCRIPTION,
        startDate: event.start,
        endDate: event.end,
        eventStatus: 'https://schema.org/EventScheduled',
        eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
        image: [`${SITE}/assets/images/og.jpg`],
        organizer,
        performer: organizer,
        location: {
            '@type': 'Place',
            name: event.venue,
            address: {
                '@type': 'PostalAddress',
                streetAddress: event.street,
                addressLocality: event.city,
                addressRegion: event.region,
                addressCountry: 'MX'
            }
        },
        offers: {
            '@type': 'Offer',
            price: '0',
            priceCurrency: 'MXN',
            availability: 'https://schema.org/InStock',
            url: SITE,
            validFrom: '2026-08-01T00:00:00-06:00'
        }
    })).concat(faqPage)
};

export default eventSchema;
